export default __webpack_public_path__ + "static/media/avatar.a41ec8b4.png";